import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LogoProvider } from './context/LogoContext';
import Navigation from './components/Navigation';
import Artists from './components/Artists';
import ArtistPage from './components/ArtistPage';
import Works from './components/Works';
import FloatingArtworks from './components/FloatingArtworks';
import Programme from './components/Programme';

import TestProgramme from './components/TestProgramme';
import JournalGrid from './components/JournalGrid';
import SingleBlogPost from './components/SingleBlogPost';
import SingleEventPage from './components/SingleEventPage';
import Hero from './components/Hero';
import FeaturedArtworks from './components/FeaturedArtworks';
import Footer from './components/Footer';
import FontTest from './components/FontTest';
import Imprint from './components/Imprint';
import Privacy from './components/Privacy';
import SrivatsaPage from './pages/SrivatsaPage';
// KlaviyoScript removed as we're using our own newsletter solution
import NewsletterAdmin from './components/NewsletterAdmin';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes
    },
  },
});

// Main app component
import { useState } from 'react';

import { useEffect } from 'react';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  }, [isMenuOpen]);

  return (
    <QueryClientProvider client={queryClient}>
      <LogoProvider>
        <Router>
          <div className="bg-white min-h-screen flex flex-col">
            <Navigation isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
            
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={
                  <div className="home-page">
                    <div className="relative">
                      {/* Using the improved Hero component */}
                      <Hero />
                    </div>
                    <FeaturedArtworks />
                  </div>
                } />
                <Route path="/artists" element={<Artists />} />
                <Route path="/artist/:slug" element={<ArtistPage />} />
                <Route path="/works" element={<FloatingArtworks />} />
                <Route path="/works/:slug" element={<Works />} />
                <Route path="/programme" element={<Programme />} />
                <Route path="/programme/:slug" element={<SingleEventPage />} />
                <Route path="/test-programme" element={<TestProgramme />} />
                <Route path="/journal" element={<JournalGrid />} />
                <Route path="/journal/:slug" element={<SingleBlogPost />} />
                <Route path="/font-test" element={<FontTest />} />
                <Route path="/imprint" element={<Imprint />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/srivatsa" element={<SrivatsaPage />} />
                <Route path="/admin/newsletter" element={<NewsletterAdmin />} />
                
              </Routes>
            </main>

            <Footer />
          </div>
        </Router>
      </LogoProvider>
    </QueryClientProvider>
  );
}

export default App;